import IconYoutube from "../img/YOUTUBE.png";
import IconDownload from "../img/DOWNLOAD.png";
import IconRD from "../img/RD.png";
import IconAPK from "../img/APK.png";
import IconSpace from "../img/SPACE.png"

const configuracaoDisponibilidade = {
  Youtube: {
    label: "Assistir",
    icone: IconYoutube
  },
  APK: {
    label: "Instalar",
    icone: IconAPK
  },
  Download: {
    label: "Baixar",
    icone: IconDownload
  },
  RD: {
    label: "Acessar",
    icone: IconRD
  },
  Space: {
    label: "Abrir",
    icone: IconSpace
  }
};

export default configuracaoDisponibilidade;